import L from "leaflet";

const DEFAULT_TYPE_STYLES = {
  task: { color: "#2a72cf", icon: "fas fa-tasks" },
  finding: { color: "#f2994a", icon: "fas fa-exclamation-circle" },
  inspection: { color: "#27ae60", icon: "fas fa-clipboard-check" },
};

const looksLikeFA = (s) =>
  typeof s === "string" && /\bfa[srldb]?\b|\bfa-\w+/.test(s);

export function createMarker(item, typeStyles = {}, options = {}) {
  const styles = { ...DEFAULT_TYPE_STYLES, ...typeStyles };
  const t = item.type || "task";
  const base = styles[t] || styles.task;
  const iconName = item.iconName || item.IconName || "";
  const iconImage = item.iconImage || item.IconImage || "";
  const bg = item.iconColour || item.IconColour || base.color || "#3f51b5";

  const centerHtml = iconImage
    ? `<img src="${iconImage}" class="wm-img" style="width:26px;height:26px" alt="">`
    : looksLikeFA(iconName) || base.icon
    ? `<i class="${looksLikeFA(iconName) ? iconName : base.icon} wm-fa"></i>`
    : "";

  const badge = Number.isFinite(item.index) ? `<span class="wm-badge">${item.index}</span>` : "";

  const html = `
    <div class="wm-circle" style="background:${bg};border-color:${bg}">
      ${centerHtml}
      ${badge}
    </div>
  `;

  const divIcon = L.divIcon({
    className: "wm",
    html,
    iconSize: [32, 32],
    iconAnchor: [16, 16],
  });

  const marker = L.marker([item.lat, item.lng], {
    icon: divIcon,
    title: item.title || "",
    bubblingMouseEvents: true,
    ...(options.markerOptions || {}),
  });

  let accuracyCircle = null;
  if (options.showAccuracy && item.accuracy && item.accuracy > 0) {
    accuracyCircle = L.circle([item.lat, item.lng], {
      radius: item.accuracy,
      color: bg,
      weight: 1,
      opacity: 0.25,
      fillOpacity: 0.08,
      interactive: false,
      bubblingMouseEvents: false,
    });

    accuracyCircle.off();
    accuracyCircle.options.interactive = false;
    accuracyCircle.options.bubblingMouseEvents = false;
    accuracyCircle.on("add", function () {
      const element = this._path || this._renderer?._container;
      if (element) {
        element.style.pointerEvents = "none";
        element.style.cursor = "default";
      }
    });
  }

  return { marker, accuracyCircle };
}
